// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"01d8daf8","164":"e5a179e1","254":"0efb9d6b","301":"74ca10e9","444":"db1201c3","453":"3e1a79b0"}[chunkId] + ".chunk.js";
};